import axiosInstance from './axiosInstance';
import { Unit, CreateUnitDto, UpdateUnitDto } from '../types/units.types';

const unitsService = {
  getAll: async (): Promise<Unit[]> => {
    const response = await axiosInstance.get<Unit[]>('/Units');
    return response.data;
  },

  getById: async (id: number): Promise<Unit> => {
    const response = await axiosInstance.get<Unit>(`/Units/${id}`);
    return response.data;
  },

  create: async (unit: CreateUnitDto): Promise<Unit> => {
    const response = await axiosInstance.post<Unit>('/Units', unit);
    return response.data;
  },

  update: async (id: number, unit: UpdateUnitDto): Promise<Unit> => {
    const response = await axiosInstance.put<Unit>(`/Units/${id}`, unit);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/Units/${id}`);
  },

  generateCode: async (): Promise<string> => {
    try {
      const response = await axiosInstance.get<string>('/Units/generate-code');
      return response.data;
    } catch (error) {
      // إذا فشل، نولّد كود عشوائي
      return `UNIT-${Date.now()}`;
    }
  }
};

export default unitsService;